import React, { FC, Suspense } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import './App.less';
import 'normalize.css';
// import { Button } from 'antd';
import routes from '@router/index';
import Login from '@views/login';
import Pswd from '@views/pswd';

const Loading = () => {
  return <div className="loading">加载中...</div>;
};
const App: FC = () => {
  // 返回路由
  const RouteItem = (props: any) => {
    const { redirect, path, component, key } = props;
    if (redirect) {
      return <Redirect exact key={key} from={path} to={redirect} />;
    }
    return <Route key={key} component={component} path={path} />;
  };

  // 获取子路由
  const loopRoute = (route: any, i: number, _path?: string) => {
    return route.children.map((routeChild: any, idx: any) => {
      const r_path = route.path + routeChild.path;
      const { redirect, component } = routeChild;
      if (routeChild.children && routeChild.children.length) {
        // 递归获取子路径
        return loopRoute(routeChild, idx, r_path);
      } else {
        const route_path = _path
          ? _path + routeChild.path
          : route.path + routeChild.path;
        return RouteItem({
          key: `${i}-${idx}`,
          redirect,
          path: route_path,
          component,
        });
      }
    });
  };

  const Routes = routes.map((route: any, key) => {
    return Array.isArray(route.children) && route.children.length
      ? loopRoute(route, key)
      : RouteItem({ key, ...route });
  });
  return (
    <div className="App">
      <Suspense fallback={<Loading />}>
        <Switch>

          <Route path="/pswd" exact component={Pswd} />
          <Route path="/login" exact component={Login} />
          <Route path="/" exact component={Login} />
        </Switch>
      </Suspense>
    </div>
  );
};

export default App;
